import 'babel-polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import Modal from 'react-modal';
import 'eventsource/lib/eventsource-polyfill';

import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css';
import 'material-design-icons/iconfont/material-icons.css';
import './styles/old';

import { Router } from './routing/Router';
import { store } from './config/store';

Modal.setAppElement('#root');

ReactDOM.render(
    <Provider store={store}>
        <Router />
    </Provider>,
    document.getElementById('root'),
);
